import { APP_BASE_HREF } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { SecurityService } from '@app/_core/services/security.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { FilteredList } from '@app/_entities/filtered-list';
import { FilterDialogComponent } from '@app/pages/common/filter-dialog/filter-dialog.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { TableLazyLoadEvent } from 'primeng/table';
import { catchError, EMPTY, map } from 'rxjs';
import { QueuesService } from '@app/_core/services/queues.service';
import { ViewVoicemailDetailsComponent } from '../view-voicemail-details/view-voicemail-details.component';
import { HeaderComponent } from '@app/_core/components/header/header.component';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
import { DialerService } from '@app/_core/services/dialer.service';

@Component({
  selector: 'app-usermenuvoicemails',
  templateUrl: './usermenuvoicemails.component.html',
  styleUrls: ['./usermenuvoicemails.component.scss'],
})
export class UsermenuvoicemailsComponent implements OnInit, OnDestroy {
  @Input()
  isCloseable: any;
  vMailCount: number=0;
  lastEvent: TableLazyLoadEvent | null = null
    clientAbbreviation: any = '';
    filterModalRef?: BsModalRef;
  loadVoicemailTimeout: any;
  constructor(
    private cdr: ChangeDetectorRef,
    private utils: Utils,
    private webStorage: WebStorageService,
    private appService: AppService,
    private managerService: ManagerService,
    private securityService: SecurityService,
    private router: Router,
    private modalService: BsModalService,
    @Inject(APP_BASE_HREF) public baseHref: string,
    public bsModalRef: BsModalRef,
    private queueServices: QueuesService,
      private headerComponent: HeaderComponent,
      private dailerService: DialerService,
    private tmQueueService: TmQueueService,
  ) {
    this.pl = {
      rowOffset: 0,
      rowCount: 10,
      filterOptionRequestColumn: this.filterOptionRequestColumn,
      searchValue: this.searchValue,
      searchField: this.searchField.value,
      filterDict: this.filterDict,
      sortColumn: this.sortColumn,
      sortDescend: this.sortDescend,
      currentUserOnly: true,
      isExport: false,
      filter: null,
    };
    this.searchField = this.findOptions[0];

    this.managerService.VoiceMailCount.subscribe((res)=>
      {
        this.vMailCount=res;
      })
  }

  innerHeight = 10;
  showTable: boolean = true;
  showCrud: boolean = false;

  first = 0;
  totalRecords: number;
  loading: boolean;
  modalRef?: BsModalRef;

  voiceMailList: any = [];

  localStorageName = 'UserMenuVoicemailsColumnDisplaySettings';
  headercount: any = { shown: 0, hidden: 0 };

  /*globalfilter*/
  findOptions: any = [
    { label: 'User', value: 'User' },
    { label: 'Company', value: 'Company' },
    { label: 'User Phone', value: 'UserPhoneNumber' },
    { label: 'Inbound Phone', value: 'InboundPhoneNumber' },
    { label: 'Request Type', value: 'RequestType' },
    { label: 'Interaction ID', value: 'InteractionID' },
    { label: 'Voicemail ID', value: 'VoicemailID' },
  ];

  rowOffset = null;
  rowCount = null;
  searchField: any = { label: '', value: '' };
  searchValue: any = '';
  filterDict: any = null;
  sortColumn = '';
  sortDescend = false;
  filterOptionRequestColumn = null;
  pl: any = {};
  filteredList = new FilteredList();

  cols: any = [
    { name: 'User', label: 'User', showFilter: false },
    { name: 'UserPhoneNumber', label: 'User Number', showFilter: false },
    { name: 'InboundPhoneNumber', label: 'Inbound Number', showFilter: false },
    { name: 'Queue', label: 'Queue', showFilter: true },
    { name: 'RequestType', label: 'Request Type', showFilter: true },
    { name: 'Status', label: 'Status', showFilter: true, sortable: false },
    { name: 'Created', label: 'Created', type: 'date' },
  ];

  ngOnInit(): void {
    this.initializeColumnHeader();
  }

  initializeColumnHeader() {
    const localCol = this.webStorage.getItemFromLocalStorage(this.localStorageName);
    if (localCol != null) {
      this.cols = localCol;
    } else {
      for (const col of this.cols) {
        if (col.name == this.sortColumn) {
          if (this.sortDescend) {
            col.isAsc = false;
          } else {
            col.isAsc = true;
          }
        } else {
          delete col.isAsc;
        }
        col.hide = false;
      }
      this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    }
    this.getColumnCount();
  }

  /*globalFilter*/
  // clearSearchBox() {
  //   this.searchValue = '';
  //   this.pl['searchField'] = { label: '', value: '' };
  //   this.loadVoicemail(null);
  // }
  clearSearchBox() {
    this.searchValue = '';
    this.searchField = { label: '', value: '' };
    this.pl = {
      rowOffset: 0,
      rowCount: 10,
      filterOptionRequestColumn: null,
      searchValue: '',
      searchField: '',
      filterDict: null,
      sortColumn: this.sortColumn,
      sortDescend: this.sortDescend,
      currentUserOnly: true,
      isExport: false,
      filter: null
    };
  
    this.lastEvent = null;
    this.loadVoicemail(null);
  }
  clearFilter() {
  this.cols.forEach(col => 
    {
  delete col.filterVals;
    });
    this.cols.forEach(col => {
      if (col.filterVals) {
        col.filterVals.forEach(v => v.checked = false);
      }
    });
  
    this.filteredList.user = [];
    this.filteredList.userPhone = [];
    this.filteredList.inboundPhone = [];
    this.filteredList.queue = [];
    this.filteredList.status = [];
    this.filteredList.agent = [];
    this.filteredList.company = [];
    this.filterDict = null;
    this.lastEvent = null;
    this.pl = {
      rowOffset: 0,
      rowCount: 10,
      filterOptionRequestColumn: null,
      searchValue: this.searchValue || '',
      searchField: this.searchField?.value || '',
      filterDict: null,
      sortColumn: this.sortColumn,
      sortDescend: this.sortDescend,
      currentUserOnly: true,
      isExport: false,
      filter: null
    };
    this.loadVoicemail(null);
    }
  applyFilterByField(val: any) 
  {
    this.searchField = val.searchField;
    this.searchValue = val.searchValue;
    this.pl.searchField = this.searchField?.value ?? '';
    this.pl.searchValue = this.searchValue ?? '';
    if (!this.searchValue || this.searchValue.trim() === '') 
      {
      this.pl.searchField = '';
      this.pl.searchValue = '';
     }
    this.first = 0;
    this.lastEvent = null;
    this.loadVoicemail(null);
   }
toggleCustomColumnFilter(colName: string)
 {
  const col = this.cols.find(c => c.name === colName);
  if (col?.filterVals?.length) {
    this.showColumnFilterModal(colName);
    return;
  }
  this.filterOptionRequestColumn = colName;
  this.pl.filterOptionRequestColumn = colName;
  this.loadVoicemail(null);
}
  sortByColumn(colName: string) {
    this.sortColumn = colName;
    this.sortDescend = !this.sortDescend;
    this.cols = this.utils.sortByFieldInServer(colName, this.cols);
    this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    this.loadVoicemail(null);
  }

  onRowSelect(event: any) {
    this.managerService.GetVoicemailByID(event.data.ID).subscribe((result)=>{
      this.loadVoicemail(null);
      this.queueServices.setselectedQueueId(event.data.QueueID);
      this.queueServices.setIsPageLoadCompleted(false);
      this.appService.setselectedQueueId(event.data.QueueID);
      this.headerComponent.getInboundCallStats(event.data.QueueID);
      //this.appService.setSelectedQueueName(event.data.Queue); // This changes the Queue Name in the header to selected record Queue Name (which is wrong).
      this.appService.setActivityId(event.data.ActivityID);
        this.tmQueueService.getQueueInfo(event.data.QueueID).subscribe(data => {
          this.appService.SetQueueInfo(data.Response.Data);
        });
      //this.router.navigateByUrl(this.router.url + "/Details/" + event.data.ID)
      this.tmQueueService.getOptionsForQueue(event.data.QueueID).subscribe(data => {
        if (data) {
          this.appService.setSelectedQueueType(data.Response.Data.Type);
         // console.log(data.Response.Data.Type);
        }
      });
      const config: ModalOptions = { class: 'modal-xl modal-wide' };
      const initialState: ModalOptions = {
        class: 'modal-xl modal-wide',
        initialState: {
          data: result.Response.Data,
          title: 'Voicemail from ' + event.data.UserPhoneNumber + ' - @ ' + this.utils.formatDateTime(event.data.Created),
        },
      };
      this.modalRef = this.modalService.show(ViewVoicemailDetailsComponent, initialState);
      this.modalRef.content.deleted?.subscribe(() => {
       //this.loadVoicemail(null);
       this.modalRef = null; 
       this.loadVoicemail(this.lastEvent ?? null);
        });
      this.modalRef.content.closeWindow.subscribe((result: any) => {
        if(result){
          //this.closeVoicemailsPopup();
          this.loadVoicemail(this.lastEvent ?? null);
          this.bsModalRef.hide();
          this.modalRef = null;
        }
      });
    })
    
  }

  getColumnCount() {
    let shown = 0;
    let hidden = 0;
    for (const header of this.cols) {
      if (header.hide) {
        hidden++;
      } else {
        shown++;
      }
    }
    this.headercount.shown = shown;
    this.headercount.hidden = hidden;
  }

  storeFilteredList(colData, colName) {
    switch (colName) {
      case 'User':
        this.filteredList.user = colData.filterVals;
        break;
      case 'UserPhoneNumber':
        this.filteredList.userPhone = colData.filterVals;
        break;
      case 'InboundPhoneNumber':
        this.filteredList.inboundPhone = colData.filterVals;
        break;
      case 'Queue':
        this.filteredList.queue = colData.filterVals;
        break;
      case 'Status':
        this.filteredList.status = colData.filterVals;
        break;
    }
  }

  getFilteredList(colName) {
    switch (colName) {
      case 'User':
        return this.filteredList.user;
      case 'UserPhoneNumber':
        return this.filteredList.userPhone;
      case 'InboundPhoneNumber':
        return this.filteredList.inboundPhone;
      case 'Queue':
        return this.filteredList.queue;
      case 'Status':
        return this.filteredList.status;
    }
    return null;
  }
  getColDetails(cols, filteredList) {
    if (filteredList) {
      for (const col of cols) {
        if (col.name == 'User') {
          if (filteredList.user?.length > 0) {
            col.filterVals = filteredList.user;
          }
        }
        if (col.name == 'UserPhoneNumber') {
          if (filteredList.userPhone?.length > 0) {
            col.filterVals = filteredList.userPhone;
          }
        }
        if (col.name == 'InboundPhoneNumber') {
          if (filteredList.inboundPhone?.length > 0) {
            col.filterVals = filteredList.inboundPhone;
          }
        }
        if (col.name == 'Queue') {
          if (filteredList.queue?.length > 0) {
            col.filterVals = filteredList.queue;
          }
        }
        if (col.name == 'Status') {
          if (filteredList.status?.length > 0) {
            col.filterVals = filteredList.status;
          }
        }
      }
    }
  }
  showColumnFilterModal(colName: string) 
  {
    if (this.filterModalRef) {
      this.filterModalRef.hide();
      this.filterModalRef = null;
    }
    this.cdr.detectChanges();
    this.getColDetails(this.cols, this.filteredList);
    const clonedCols = JSON.parse(JSON.stringify(this.cols));
    const initialState = {
      cols: clonedCols,
      colName
    };
    const config: ModalOptions = {
      class: 'task-menu',
      backdrop: 'static',
      initialState
    };
  
    this.filterModalRef = this.modalService.show(FilterDialogComponent, config);
  
    this.filterModalRef.onHidden?.subscribe(() => {
      this.filterModalRef = null;
    });
  
    this.filterModalRef.content.event.subscribe((result: any) => {
      this.cols = result.data;
      this.cdr.detectChanges();
      this.storeFilteredList(this.cols, colName);
      this.applyColumnFilters();
    });
  }
  applyColumnFilters() {
    this.filterDict = [];
    this.filterOptionRequestColumn = null;
  
    this.cols.forEach(col => {
      if (!col.filterVals) return;
  
      const selected = col.filterVals
        .filter(v => v.checked)
        .map(v => v.name);
  
      if (selected.length > 0) {
        const apiKey = this.correctFilterColumnName(col.name);
        this.filterDict.push({
          Key: apiKey,
          Value: selected
        });
      }
    });
  
    if (this.filterDict.length === 0) {
      this.filterDict = null;
    }
  
    this.pl.rowOffset = 0;
    this.pl.filterDict = this.filterDict;
    this.lastEvent = null;
  
    this.loadVoicemail(null);
  }
  correctFilterColumnName(colName: string): string {
    switch (colName) 
    {
      case 'UserPhoneNumber':
        return 'User Phone';
      case 'InboundPhoneNumber':
        return 'Inbound Phone';
      case 'RequestType':
        return 'Request Type';
      case 'Queue':
        return 'Queue';
      case 'Status':
        return 'Status';
      default:
        return colName;
    }
  }
  closeVoicemailsPopup() {
    // Reset Queue
      this.appService.setSelectedQueueType(this.router.url.split("?")[0].split("/").pop());
      let type = this.router.url.split("?")[0].split("/").pop();
      let url = this.queueServices.getQueueRoute();
      let queueID = this.queueServices.getselectedQueueId();
      if (url.toLowerCase().includes('inbound') && url.toLowerCase().includes('qid')) {
          this.clientAbbreviation = Utils.fetch('clientAbbreviation');
          this.dailerService.setDialerCancelledStatus(false);
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              // this.router.navigate([this.clientAbbreviation + '/Queue/' + selectedQueue.type]);
              this.router.navigate([this.clientAbbreviation + '/Queue/' + type], {
                  queryParams: { qid: queueID},
              });
          });
      }
    // Reset QueueID
    // this.queueServices.setselectedQueueId(this.router.url.split('?')[1].split("=").pop()); 
    // this.appService.setselectedQueueId(this.router.url.split('?')[1].split("=").pop()); 

    this.bsModalRef.hide();
  }
  loadVoicemail(event: TableLazyLoadEvent | null) {
    // this.pl = {
    //   "rowOffset": 0,
    //   "rowCount": 10,
    //   "filterOptionRequestColumn": this.filterOptionRequestColumn,
    //   "searchValue": this.searchValue,
    //   "searchField": this.searchField.value,
    //   "filterDict": this.filterDict,
    //   "sortColumn": this.sortColumn,
    //   "sortDescend": this.sortDescend,
    //   "currentUserOnly": true,
    //   "isExport": false,
    //   "filter": null

    // };
   // console.log('pl', this.pl);
  //  if (event) {
  //   this.lastEvent = event;
  //   this.pl.rowOffset = event.first;
  //   this.pl.rowCount = event.rows;
  // }
  //   this.loading = true;
  //   if (event == null) {
  //     this.resetTable();
  //   } else {
  //     this.pl.rowOffset = event.first;
  //     this.pl.rowCount = event.rows;
  //   }
  
  this.loading = true;
// Normalize incoming event or reuse lastEvent or fallback to defaults
if (event) {
  this.lastEvent = {
    ...event,
    first: event.first ?? 0,
    rows: event.rows ?? (this.pl?.rowCount ?? 10),
  };
  this.pl.rowOffset = this.lastEvent.first;
  this.pl.rowCount  = this.lastEvent.rows;
} else if (this.lastEvent) {
  this.pl.rowOffset = this.lastEvent.first ?? 0;
  this.pl.rowCount  = this.lastEvent.rows ?? (this.pl?.rowCount ?? 10);
} else {
  // first-time fallback (don’t use resetTable here)
  this.pl.rowOffset = 0;
  this.pl.rowCount  = this.pl?.rowCount ?? 10;
}
     this.loadVoicemailTimeout = setTimeout(
      () => {
        //load data of required page
        if (this.filterOptionRequestColumn != null) {
          this.pl.filterOptionRequestColumn = this.filterOptionRequestColumn;
        }
        this.managerService
          .GetVoicemails(this.pl)
          .pipe(
            map((data: any) => {
              const isValid = ResponseHandler.processResponse(data, 'GetVoicemails');
              if (isValid) {
                if (this.filterOptionRequestColumn != null) {

                  const columnName = this.filterOptionRequestColumn;
                
                  this.filterOptionRequestColumn = null; 
                  this.pl.filterOptionRequestColumn = null;
                
                  const filterVals = [];
                
                  for (const dt of data.Response.Data) {
                    if (dt != null && dt.trim() !== '') {
                      filterVals.push({ name: dt, checked: false });
                    }
                  }
                
                  for (const col of this.cols) {
                    if (col.name === columnName) {
                      col.filterVals = filterVals;
                    }
                  }
                
                  this.showColumnFilterModal(columnName);
                  return;
                }
             else 
                {
                  this.voiceMailList = data.Response.Data.Data;
                  if (data.Response.Data.TotalFilteredItems) {
                    this.totalRecords = data.Response.Data.TotalFilteredItems;
                  } else {
                    this.totalRecords = 0;
                  }
                  this.loading = false;
                }
          const currentOffset = this.lastEvent?.first ?? this.pl.rowOffset ?? 0;
          const pageSize = this.lastEvent?.rows ?? this.pl.rowCount ?? 10;
          if (this.voiceMailList.length === 0 && this.totalRecords > 0) {
          const newOffset = Math.max(0, currentOffset - pageSize);
          if (newOffset !== currentOffset) 
          {
         this.lastEvent = { ...(this.lastEvent || {}), first: newOffset, rows: pageSize };
         this.pl.rowOffset = newOffset;
         this.loadVoicemail(this.lastEvent);
          return;
          }
          }
                //trigger change detection
                //event.forceUpdate();
                if (event && event.forceUpdate) {
                  event.forceUpdate();
              }
                this.setInnerWidthHeightParameters();
              } else {
              }
            }),
            catchError(error => {
              this.loading = false;
              return EMPTY;
            })
          )
          .subscribe();
      },
      Math.random() * 1000 + 250
    );
  }
  resetTable() {
    this.first = 0;
    this.voiceMailList = [];
    this.totalRecords = 0;

    this.pl['rowOffset'] = this.rowOffset;
    this.pl['rowCount'] = this.rowCount;
    if (this.filterDict != null) {
      this.pl['filterDict'] = this.filterDict;
    } else {
      this.pl['filterDict'] = null;
    }
    this.pl['filterOptionRequestColumn'] = this.filterOptionRequestColumn;
    this.pl['filter'] = null;
    this.pl['sortDescend'] = this.sortDescend;
    this.pl['sortColumn'] = this.sortColumn;
    this.pl['searchValue'] = this.searchValue;
    this.pl['searchField'] = this.searchField.value;
  }
  setInnerWidthHeightParameters() {
    this.innerHeight = window.innerHeight * 0.07;
  }
  ngOnDestroy(): void {
    this.loadVoicemailTimeout && clearTimeout(this.loadVoicemailTimeout);
  }
}
